module.exports = __webpack_public_path__ + "img/zaixianqianm@2x.714b6a69.png";